import React, { useState, useCallback, useEffect } from 'react'
import ReactCrop from 'react-image-crop';

import '../../../assets/sass/components/images/crop-image.scss';

const CropImage = ({
    image,
    onChange,
    base64 = true,
    cropOptions = {}
}) => {
    const [imgRef, setImgRef] = useState();
    const [upImage, setUpImage] = useState();
    const [crop, setCrop] = useState({ unit: '%', width: 50, height: 50, x: 10, y: 10, aspect: 1, ...cropOptions });

    const onLoad = useCallback(img => {
        setImgRef(img);
    }, []);

    useEffect(() => {
        if (image && typeof image !== 'string') {            
            const reader = new FileReader();
            reader.addEventListener('load', () => setUpImage(reader.result));
            reader.readAsDataURL(image);
        } else if (image && typeof image === 'string') {
            setUpImage(image);
        }
    }, []);

    useEffect(() => {
        makeClientCrop(crop);
    }, [imgRef]);

    const makeClientCrop = async crop => {
        if (imgRef && crop.width && crop.height) {
            const imgUrl = await createCropPreview(imgRef, crop, 'profile_image.jpeg');            
            onChange(imgUrl);
        }
    };

    const createCropPreview = async (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            if(base64) {
                const imageUrl = canvas.toDataURL('image/png');
                resolve(imageUrl);
            } else {
                canvas.toBlob(blob => {
                    if (!blob) {
                        reject(new Error('Canvas is empty'));
                        return;
                    }
                    blob.name = fileName;
                    const imageUrl = window.URL.createObjectURL(blob);
                    resolve(imageUrl)
                }, 'image/png');
            }
        });
    };

    return (
        <ReactCrop
            src={upImage}
            onImageLoaded={onLoad}
            crop={crop}
            onChange={setCrop}
            onComplete={makeClientCrop}
        />
    )
}

export default CropImage